import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectBuildingLiftTypesTypeFilter } from 'shared/selectors/advancedFilters';
import { EBuildingElevatorType } from '../../../../../../../packages/api-models/common/json_query';
import { NonEmptyArray } from '../../../../../../../packages/JsonQuery';

export const BuildingLiftTypesTypeContainer: FC = () => {
  const { label, value, options } = useSelector(selectBuildingLiftTypesTypeFilter);

  const onChange = useFilterChangeCallback();

  const handleBuildingLiftTypesTypeChange = useCallback(
    (newValue: NonEmptyArray<EBuildingElevatorType> | null) => {
      onChange({ action: 'setBuildingLiftTypesType', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter
        value={value}
        options={options}
        onFilterChange={handleBuildingLiftTypesTypeChange}
      />
    </AdvancedFilterRow>
  );
};
